import { sitecoreApiKey } from '@shared/configs/configs/config';
import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_ARTICLES_BY_TEXT_URL } from '@shared/utils/api/configs/URL';

import type { GetArticlesByTextPayload, GetArticlesByTextResult } from '../types/getArticlesByText.types';

export const HOME_PAGE_ARTICLES_BY_TEXT_TAGS = 'getArticlesByText';

export const getArticlesByText = (builder: BuilderType) =>
  builder.query<GetArticlesByTextResult, GetArticlesByTextPayload>({
    providesTags: [HOME_PAGE_ARTICLES_BY_TEXT_TAGS],
    query: (params) => ({
      method: 'POST',
      data: {
        ...params,
        VariantID: '{25D068AF-098D-4C47-8006-C78CBF8F5B54}',
        PageSize: 3,
        Languages: ['en'],
        ScopesIDs: ['{94626D83-F740-47E6-A9DD-8FD8FFAC09D5}'],
      },
      overrideOptions: {
        headers: {
          sc_apikey: sitecoreApiKey(),
        },
        params: {
          sc_apikey: sitecoreApiKey(),
        },
        withCredentials: false,
      },
      url: GET_ARTICLES_BY_TEXT_URL,
    }),
    transformResponse: (response: GetArticlesByTextResult) => {
      if (response) {
        return response;
      }

      throw {
        code: '400',
        message: 'Unknown error occurred',
      };
    },
  });
